import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { func } from 'prop-types'
import { withRouter } from 'react-router'
import { ProfilePicture } from '../../components/ui/ProfilePicture'
import { UpdateProfilePictureButton } from '../../components/ui/buttons/UpdateProfilePictureButton'
import { stores, view } from '../../stores'
import { SubHero } from '../../components/header/SubHero'
import { AccountEdit } from '../../components/customer/AccountEdit'
import { PagesPaths } from '../../constants/Pages'

class EditAccountPageComponent extends Component {
  componentWillMount () {
    stores.account.refreshAccount()
  }

  render () {
    const { t } = this.props
    const breadcrumb = [{ name: t('common:account:my'), path: PagesPaths.ACCOUNT.path }]
    return (
      <div>
        <SubHero breadcrumb={breadcrumb} />
        <div className='layout__container account'>
          <h2 style={{fontWeight: 500}}>{t('common:account:personnal')}</h2>
          <div className='account__edit'>
            <ProfilePicture className='account__img' rounded picture={stores.account.connected ? stores.account.connected.profilePicture : null} />
            <UpdateProfilePictureButton />
            <AccountEdit />
          </div>
        </div>
      </div>
    )
  }
}

EditAccountPageComponent.propTypes = {
  t: func
}

export const EditAccountPage = withRouter(translate()(view(EditAccountPageComponent)))



// WEBPACK FOOTER //
// ./src/pages/compte/EditAccountPage.js